import { ValueOf } from '@guiker/ts-utils'

export const InvestorProfileStatus = {
  CREATED: 'CREATED',
  INFORMATION_COMPLETED: 'INFORMATION_COMPLETED',
} as const

export type InvestorProfileStatus = ValueOf<typeof InvestorProfileStatus>
